__turbopack_context__.v({
  "footer": "footer-module-scss-module__iGR4oq__footer",
  "footerContent": "footer-module-scss-module__iGR4oq__footerContent",
  "footerLink": "footer-module-scss-module__iGR4oq__footerLink",
});
